<template>
  <div id='app'>
    <bar-progress />
    <request-error />
    <transition name='fade-up' mode='out-in'>
      <router-view/>
    </transition>
  </div>
</template>

<script>
  import BarProgress from './components/BarProgress';
  import RequestError from './components/RequestError';

  export default {
    name: 'app',
    components: { BarProgress, RequestError },
  };

  /* eslint-disable no-console */
  const style = [
    'background: linear-gradient(45deg, #6e7a78 0%, #3b434d 100%);',
    'color: white',
    'padding: 24px 26px',
    'font-size: 12px',
    'line-height: 68px',
  ].join(';');
  console.log('%c TD Score | https://score.transformacaodigital.com', style);
</script>

<style lang='scss'>
  @import './assets/css/global.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue